import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { UsersService } from '../services/users.service';

@Component({
selector: 'app-forget-password',
templateUrl: './forget-password.component.html',
styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;

	email: string = "";
	token: string = "";

	constructor(
		private usersService: UsersService,
		private toastrService: ToastrService,
		private router: Router
	) { }

	ngOnInit(): void {
	}

	// when click button Réinitialiser
	reInit(): void{
		this.blockUI.start('Loading');
		this.usersService.forgetCorePassword(this.email).subscribe(
			(res) => {
				if (res.success){
					this.token = res.data.token;
					this.blockUI.stop();
					// change to next screen
					let forgetPwd = document.getElementById("forget-pwd");
					forgetPwd.style.display = "none";
					let emailSent = document.getElementById("email-sent");
					emailSent.style.display = (emailSent.style.display === "none")?"block":"none";
				}
				else{
					this.blockUI.stop();
					if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('EMAIL_NOT_EXIST')){
						this.toastrService.error("Email n'existe pas");
					} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
			}
		)
	}

	// when click button Renvoyer l’email
	reSendEmail(): void{
		let emailSent = document.getElementById("email-sent");
		emailSent.style.display = (emailSent.style.display === "none")?"block":"none";
		let forgetPwd = document.getElementById("forget-pwd");
		forgetPwd.style.display = (forgetPwd.style.display === "block")?"none":"block";
	}

	// when click button Se connecter
	login(): void{
		this.router.navigate(['/bo/connexion']);
	}
}
